import { Pencil } from "lucide-react";
import { Button } from "react-aria-components";

type EditButtonProps = {
  /** Names the field in the accessible name ("Edit <label>"). */
  label: string;
  onPress: () => void;
};

export function EditButton({ label, onPress }: EditButtonProps) {
  return (
    <Button
      aria-label={`Edit ${label}`}
      className="inline-flex h-9 shrink-0 cursor-pointer items-center gap-1.5 rounded-lg px-2.5 text-sm font-semibold text-fg-brand-primary outline-hidden transition-colors hover:bg-bg-brand-primary focus-visible:ring-2 focus-visible:ring-border-brand"
      onPress={onPress}
    >
      <Pencil className="size-4" />
      Edit
    </Button>
  );
}
